import React, { Component } from "react";
import { useState, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../components/shared/Footer";
import Select, { ActionMeta } from "react-select";
import * as APIModels from "../../models";
import { ReportService } from "../../services/SubmissionService";
import AttorneySelect from "../../components/shared/AttorneySelect";
import { DataService } from "../../services/DataService";
import { RecordsService } from "../../services/RecordsService";
import CorrectionQueue from "./CorrectionQueue";
import { SubmissionService } from "../../services/SubmissionService";
import EFileModal from "./modals/EFileModal";

type NameValueOptionType = { label: string; value: string };

export default function MyCases() {
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [modalShow, setModalShow] = useState(false);

    const [caseTitle, setCaseTitle] = useState("");
    const [caseNumber, setCaseNumber] = useState("");

    const [reportRequest, setReportRequest] = useState(
        new APIModels.EFileReportRequest()
    );
    const [attorneyId, setAttorneyId] = useState("");
    const [attorneyName, setAttorneyName] = useState("");
    const [firmId, setFirmId] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [totalPages, setTotalPages] = useState("100");

    const [data, setData] = useState([] as APIModels.CourtCase[]);
    const [selectedCase, setSelectedCase] = useState(new APIModels.CourtCase());

    const [stateOptions, setStateOptions] = useState(
        [] as NameValueOptionType[]
    );
    const [stateId, setStateId] = useState("");

    const [countyId, setCountyId] = useState("");
    const [countyOptions, setCountyOptions] = useState(
        [] as NameValueOptionType[]
    );

    const [search, setSearch] = useState(false);

    const onAttorneySelected = (id: string, name: string) => {
        setAttorneyId(id);
        setAttorneyName(name);
    };

    const onFirmSelected = (id: string, name: string) => {
        setFirmId(id);
    };

    useEffect(() => {
        DataService.getStates().then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.abbreviation!, label: v.name! };
                });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        DataService.getCountiesByPortal({ state: stateId! }).then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setCountyOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [stateId]);

    const onStateChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setStateId(value?.value ?? "");
    };

    const onCountyChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setCountyId(value?.value ?? "");
    };

    const onSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSearching(true);
        setErrorMessage("");
        if (attorneyId == "") {
            setErrorMessage("Please select an attorney");
            setSearching(false);
        } else if (stateId == "" || countyId == "") {
            setErrorMessage("Please select state, county");
            setSearching(false);
        } else if (totalPages == "") {
            setErrorMessage("Please enter size of search results");
            setSearching(false);
        } else {
            RecordsService.getMyCases({
                attorneyId: attorneyId,
                countyId: countyId,
                caseStyle: caseTitle,
                caseNumber: caseNumber,
                itemsPerSearch: parseInt(totalPages),
            }).then(
                (resp) => {
                    setSearching(false);
                    if (resp) {
                        setData(resp.data as APIModels.CourtCase[]);
                    } else {
                        // setErrorMessage(resp.errorMessage ?? "");
                    }
                },
                (error) => {
                    setSearching(false);
                    setErrorMessage("An error has occurred");
                }
            );
        }
    };

    const onViewCase = (rowdata: APIModels.CourtCase) => {
        //window.location.href = `/admin/attorneyedit/${rowdata.id}`;
        window.location.href = `/pages/caseview/${attorneyId}/${countyId}/${rowdata.ucn}`;
        console.log(rowdata.caseID);
    };

    const onFileIntoCase = (rowdata: APIModels.CourtCase) => {
        setSelectedCase(rowdata);
        setModalShow(true);
    };

    const onOk = () => {
        console.log("onConfirm");
    };

    return (
        <div className="content">
            <EFileModal
                show={modalShow}
                courtCase={selectedCase}
                attorneyId={attorneyId}
                attorneyName={attorneyName}
                onOk={onOk}
                onClose={() => setModalShow(false)}
            />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">My Cases</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        <a href="javascript: void(0);">
                                            My Cases
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <form action="#" onSubmit={onSearchClick}>
                    <div className="mb-3">
                        <AttorneySelect
                            onAttorneySelected={onAttorneySelected}
                            onFirmSelected={onFirmSelected}
                        />
                    </div>
                    <div className="row">
                        <div className="col-sm-6 mb-2">
                            <label htmlFor="selState" className="form-label">
                                State
                            </label>
                            <Select
                                id="selState"
                                name="selState"
                                className="required"
                                value={stateOptions.filter(
                                    (c) => c.value === stateId
                                )}
                                options={stateOptions}
                                onChange={onStateChange}
                                required={true}
                            />
                        </div>

                        <div className="col-sm-6">
                            <label htmlFor="selCounty" className="form-label">
                                County
                            </label>
                            <Select
                                id="selCounty"
                                name="selCounty"
                                value={countyOptions.filter(
                                    (c) => c.value === countyId
                                )}
                                // filterOption={filterOption}
                                options={countyOptions}
                                onChange={onCountyChange}
                                required={true}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6 mb-2">
                            <label
                                htmlFor="txtCaseTitle"
                                className="form-label"
                            >
                                Case Title
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="txtCaseTitle"
                                aria-describedby="inputGroupPrepend"
                                onChange={(event) =>
                                    setCaseTitle(event.currentTarget.value)
                                }
                                placeholder="(Optional)"
                                // required={true}
                            />
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtContains" className="form-label">
                                Case Number
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtCaseNumber"
                                    aria-describedby="inputGroupPrepend"
                                    onChange={(event) =>
                                        setCaseNumber(event.currentTarget.value)
                                    }
                                    placeholder="(Optional)"
                                    // required={true}
                                />

                                <div className="invalid-feedback">
                                    Please provide a valid bar number.
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <label htmlFor="selCounty" className="form-label">
                                Cases Per Search
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="txtCaseNumber"
                                aria-describedby="inputGroupPrepend"
                                defaultValue={totalPages}
                                onChange={(event) =>
                                    setTotalPages(event.currentTarget.value)
                                }
                                // required={true}
                            />
                        </div>

                        <div className="text-end mb-3">
                            {searching ? (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="button"
                                    disabled={true}
                                >
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Searching...
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="submit"
                                    // onClick={onSearchClick}
                                >
                                    Search
                                </button>
                            )}
                            <div style={{ color: "red" }}>{errorMessage}</div>
                        </div>
                    </div>
                </form>

                <div className="card text-left">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                <div style={{ maxWidth: "100%" }}>
                                    <MaterialTable
                                        columns={[
                                            {
                                                title: "Case Number",
                                                field: "caseNumber",
                                                cellStyle: {
                                                    width: "100px",
                                                },
                                            },
                                            {
                                                title: "Case Title",
                                                field: "caseTitle",
                                                cellStyle: {
                                                    width: "1000px",
                                                },
                                            },
                                            {
                                                title: "County",
                                                field: "county",
                                            },
                                            {
                                                title: "Division",
                                                field: "division",
                                            },
                                        ]}
                                        data={data}
                                        title="My Cases"
                                        options={{
                                            tableLayout: "auto",
                                        }}
                                        actions={[
                                            {
                                                icon: "visibility",
                                                tooltip: "View Case",
                                                onClick: (event, rowData) =>
                                                    onViewCase(
                                                        rowData as APIModels.CourtCase
                                                    ),
                                            },
                                            {
                                                icon: "upload", //folder
                                                tooltip: "File Into Case",
                                                onClick: (event, rowData) =>
                                                    onFileIntoCase(
                                                        rowData as APIModels.CourtCase
                                                    ),
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div>
                            <CorrectionQueue attorney={attorneyId} />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
